import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RPAsRelatorioComponent } from './rpas-relatorio.component';

@NgModule({
    declarations: [RPAsRelatorioComponent],
    exports: [RPAsRelatorioComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PoModule,
        FormsModule,
    ]
})
export class RpasRelatorioModule { }
